<template>
  <div style="min-width:1290px;">
    <MyBanner />
    <MyRight />
    <div>
      <div class="w1200">
        <div style="padding:20px 0;">
          <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>帮助中心</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="box-content">
            <div class="box-content-item-x" v-for="item in PlatformDynamics" :key="item.id" @click="goDetail(item.id,3,'帮助中心')">
              <div><img src="./../static/what.png" alt="" style="width: 17.47px;height: 16.23px;vertical-align: middle;"></div>
              <div class="item-title" :title="item.title">{{item.title}}</div>
              <div class="item-time" v-if="item.updateTime&&item.updateTime!=''">{{item.updateTime.slice(5,11)}}</div>
            </div>
            <div style="display: flex;justify-content: flex-end;padding: 20px 10px 0px 20px;">
              <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :size="size" :disabled="disabled" background layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import MyRight from "@/components/RightFixd.vue";
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";
import { getAllNav, getNewsTable } from "@/api/index.js"
const router = useRouter();
let PlatformDynamics = ref();
let currentPage = ref(1)
let current = ref(1)
let pageSize = ref(10)
let disabled = ref(false)
let size = ref('default')
let total = ref()
let goDetail = (id, num, str) => {
  router.push({ path: '/platformDynamicsDetail', query: { ids: id, type: num, title: str } })
}
let handleSizeChange = (val) => {
  pageSize.value = val
  GetNewsTable()
}
let handleCurrentChange = (val) => {
  current.value = val
  GetNewsTable()
}
let GetNewsTable = async () => {
  await getAllNav().then(res => {
    res.data.forEach(item => {
      if (item.categoryName == "帮助中心") {
        getNewsTable({ current: current.value, size: pageSize.value, id: item.id }).then(res => {
          PlatformDynamics.value = res.data.records
          total.value = res.data.total
        })
      }
    })
  })
}
onMounted(async () => {
  GetNewsTable()
});
</script>
<style scoped>
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.box-content-item-x {
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 19px;
  cursor: pointer;
}
.box-content-item-x:nth-last-child(1) {
  margin-bottom: 0;
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  margin-bottom: 20px;
}
.box-content {
  height: calc(100% - 70px);
  padding: 20px;
  box-sizing: border-box;
}
.box-content-item {
  height: 24px;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 27px;
  cursor: pointer;
}
.box-content-item:nth-last-child(1) {
  margin-bottom: 0;
}
.box-content-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #999999;
}
.item-title {
  width: 80%;
  font-size: 16px;
  font-weight: 400;
  color: #444;
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-time {
  width: 19%;
  text-align: right;
  font-size: 14px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}
</style>